// extracted by mini-css-extract-plugin
export var colDays = "businessHours-module--col-days--5ca2c";
export var colHours = "businessHours-module--col-hours--85e5a";
export var colNarrow = "businessHours-module--col-narrow--abd21";
export var container = "businessHours-module--container--08321 default-module--container--edca7";
export var heading = "businessHours-module--heading--8a609 index-module--c-heading-1--61ad7 default-module--font-bold--e6812";
export var hours = "businessHours-module--hours--ab40d";
export var narrow = "businessHours-module--narrow--11b94";
export var note = "businessHours-module--note--cae15";
export var space = "businessHours-module--space--53a3e";
export var table = "businessHours-module--table--2dd20";
export var tableBody = "businessHours-module--table-body--cd5e3";
export var tableHead = "businessHours-module--table-head--b5bc9";
export var tableHeadText = "businessHours-module--table-head-text--05ca2";
export var tableWrapper = "businessHours-module--table-wrapper--edac8";